<template>
    <el-container class="layout-container">
        <el-aside>
            <el-menu
                :router="true"
                :default-active="$route.path"
                class="el-menu-vertical"
                background-color="#304156"
                text-color="#bfcbd9"
                active-text-color="#409EFF"
            >
                <el-menu-item index="/admin/compute/resource">
                    <span slot="title">算力资源管理</span>
                </el-menu-item>
                <!-- <el-menu-item index="/admin/system/consult">
          <span slot="title">咨询信息管理</span>
        </el-menu-item> -->
                <el-submenu index="1">
                    <template slot="title">
                        <span>CMS内容管理</span>
                    </template>
                    <el-menu-item index="/admin/system/news">
                        <span slot="title">新闻公告</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/system/platform">
                        <span slot="title">公共服务平台</span>
                    </el-menu-item>
                    <el-menu-item index="/admin/system/local-platform">
                        <span slot="title">地方算力平台</span>
                    </el-menu-item>
                </el-submenu>
                <!-- <el-menu-item index="/admin/dashboard">
          <i class="el-icon-menu"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>系统管理</span>
          </template>
          <el-menu-item index="/admin/system/user">
            <i class="el-icon-user"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/system/role">
            <i class="el-icon-s-check"></i>
            <span slot="title">角色管理</span>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>基础设施</span>
          </template>
          <el-menu-item index="/admin/infra/server">
            <i class="el-icon-monitor"></i>
            <span slot="title">服务器管理</span>
          </el-menu-item>
        </el-submenu> -->
            </el-menu>
        </el-aside>
        <el-container>
            <el-header style="height: 50px">
                <div class="header-left">
                    <div class="header-title">
                        全国一体化算力网国家枢纽节点（长三角）算力公共服务平台
                    </div>
                </div>
                <div class="header-right">
                    <el-dropdown trigger="click">
                        <span class="user-info">
                            <i class="el-icon-user"></i>
                            <span>管理员</span>
                            <i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleLogout"
                                >退出登录</el-dropdown-item
                            >
                            <!-- <el-dropdown-item @click.native="handleUserInfo">个人信息</el-dropdown-item> -->
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-header>
            <el-main>
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: "Layout",
    data() {
        return {
            username: "管理员",
        };
    },
    methods: {
        ...mapActions("user", ["checkTokenValidity", "logout"]),
        async handleLogout() {
            // 检查token是否有效
            let res = await this.checkTokenValidity();
            // 调用logout方法
            await this.logout(res.isValid);
            // 跳转到登录页面
            this.$router.push({ path: "/portal" });
        },
        handleUserInfo() {},
    },
};
</script>

<style lang="scss" scoped>
.layout-container {
    height: 100vh;
    padding: 0;
    .el-aside {
        background-color: #304156;
        width: 200px !important;
        .el-menu {
            border-right: none;
        }
        .el-menu-vertical {
            height: 100%;
        }
    }
    .el-header {
        background-color: #fff;
        border-bottom: 1px solid #e6e6e6;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;

        .header-left {
            .header-title {
                font-size: 18px;
                font-weight: bold;
                color: #303133;
            }
        }

        .header-right {
            .user-info {
                display: flex;
                align-items: center;
                cursor: pointer;
                color: #606266;

                i {
                    margin-right: 5px;
                    &.el-icon-caret-bottom {
                        font-size: 12px;
                        margin-left: 5px;
                    }
                }

                &:hover {
                    color: #409eff;
                }
            }
        }
    }
    .el-main {
        background-color: #f0f2f5;
        padding: 20px;
    }
}
</style>
